class ResizeScale {
    constructor (props) {
        this.state = {
            width: props.width,
            height: props.height,
            child: props.child,
            parent: props.parent,
            uselessHeight: props.uselessHeight,
            noTransForm: typeof props.noTransForm === 'undefined' ? false : props.noTransForm,
            headerHeight: props.headerHeight ? props.headerHeight : 10,
            footerHeight: props.footerHeight ? props.footerHeight : 10,
            setScale: props.isScale || true,
            onlyDestop: props.onlyDestop || false
        }

        this.init()
    }

    init () {
        this.doResize()
        window.addEventListener('resize', this.doResize())
    }

    doResize () {
        let state = this.state,
            scale = null,
            root = document.documentElement

            // console.log(state)

        scale = Math.min(
            // state.parent.getBoundingClientRect().width / state.width,
            ((state.parent.getBoundingClientRect().height - state.uselessHeight) / state.height),
        )

        // console.log('----------------------------------------------------')
        // console.log(scale);
        // console.log('PARENT H : ' + state.parent.getBoundingClientRect().height)
        // console.log('PARENT H - USELESS : ' + (state.parent.getBoundingClientRect().height - state.uselessHeight))
        // console.log('height : ' + state.height)
        // console.log('uselessHeight : ' + state.uselessHeight)

        if (state.setScale) {
            let noScale = false;

            if (state.onlyDestop) {
                noScale = (/iPad|iPhone|iPod|Android/.test(navigator.userAgent))

                // Support old ios user agent
                if (window.innerWidth <= 800 && /Safari/.test(navigator.userAgent)) {
                    noScale = true
                }
            }

            state.child.style.transform = `scale(${noScale ? .9 : (scale > 1 ? 1 : scale)})`
        }

        root.style.setProperty('--resize-scale', scale > 1 ? 1 : scale)

        if (!state.noTransForm) {
            state.child.style.transformOrigin = 'top'
        }

        // Set CSS variable
        document.documentElement.style.setProperty('--header-height', `${state.headerHeight}px`)
        document.documentElement.style.setProperty('--footer-height', `${state.footerHeight}px`)
    }
}

export default ResizeScale
